import { UserHeaderDto } from '../../data/models/dto/user-header.dto'

export const createUserHeaderDto = (
    id: string,
    isRoom: boolean,
    name: string,
    photo: string,
    profile: string,
    ticketFunctionalityActive?: boolean,
    alias?: string): UserHeaderDto => {
      return {
        id: id,
        isRoom: isRoom,
        name: name,
        photo: photo,
        profile: profile,
        alias: alias,
        ticketFunctionalityActive: ticketFunctionalityActive
      }
    }


export const createUserHeaderDtoToRoom = (
    id: string,
    isRoom: boolean,
    idsMembers: string[],
    name: string,
    photo: string,
    profile: string,
    alias?: string,
    ticketFunctionalityActive?: boolean): UserHeaderDto => {
    return {
        id: id,
        isRoom: isRoom,
        idsMembers: idsMembers,
        name: name,
        photo: photo,
        profile: profile,
        alias: alias,
        ticketFunctionalityActive: ticketFunctionalityActive
    }
}
